import type { DeepReadonly } from "@itandi/itandi-bb-ui";
import type { ReactNode } from "react";
import Styles from "./Container.module.scss";

type Props = DeepReadonly<{
	children: ReactNode;
	title: string;
}>;

export function Container({ title, children }: Props) {
	return (
		<div className={Styles.Container}>
			<h1 className={Styles.Title}>{title}</h1>
			{children}
		</div>
	);
}
